/* eslint-disable @stylistic/max-len */
import type {RefObject} from 'react';

/**
 * The `BoltIconProps` interface defines the properties for the BoltIcon component.
 */
interface BoltIconProps {
    /** CSS class to override default styling. */
    className?: string;
    /** Primary color of the icon. */
    color1?: string;
    /** Height of the icon. */
    height?: number | string;
    ref?: RefObject<SVGSVGElement>;
    /** Test ID for Cypress. */
    testId?: string;
    /** Width of the icon. */
    width?: number | string;
}

/**
 * Material Symbol "bolt" — outlined, weight 300.
 * Lightning bolt icon for the Spannung (Excitement) category.
 *
 * @param props           The component props.
 * @param props.className CSS class override.
 * @param props.color1    Primary icon color.
 * @param props.height    Icon height.
 * @param props.ref       SVG element ref.
 * @param props.testId    Test identifier.
 * @param props.width     Icon width.
 * @returns A React SVG element.
 */
export const BoltIcon = ({
    className = '',
    color1 = 'currentColor',
    height,
    ref,
    testId = 'BoltIcon',
    width
}: BoltIconProps) => (
    <svg
        ref={ref}
        className={className}
        data-cy={testId}
        fill={color1}
        height={height}
        viewBox="0 -960 960 960"
        width={width}
        xmlns="http://www.w3.org/2000/svg"
    >
        <path d="m400.69-183.08 259.77-311.53H485.85l34.07-270.23-234.53 339.45h149.76l-34.46 242.31Zm-57.61 80.77 40-277.69h-185l329.61-475.77h49.23L537.31-540H757.3L392.31-102.31h-49.23Zm130.15-372.15Z" />
    </svg>
);

BoltIcon.displayName = 'BoltIcon';